import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function EditProfile() {
    const [activeSection, setActiveSection] = useState('profile');

    function handleSubmit(e) {
        e.preventDefault();
        window.wait().then(async () => {
            await window.app.submit();
        });
    }

    return (
        <div id="wrapper">

            {/* Header component */}
            <Header />

            <div className="no-bottom no-top" id="content">
                <div id="top"></div>

                {/* section begin */}
                <section id="subheader" className="text-dark"></section>
                {/* section close */}

                {/* section begin */}
                <section aria-label="section" style={{ paddingTop: 0 }}>
                    <div className="container">
                        <div className="row wow fadeIn">
                            <div className="col-lg-3">
                                <div className="sidebar-head d-flex flex-wrap align-items-center justify-content-between">
                                    <h3 className="sidebar-head-title">Account Settings</h3>
                                    <div className="sidebar-head-action d-flex align-items-center">
                                        <div className="sidebar-drop">
                                            <a className="icon-btn menu-toggler-user-open" href="#"><em className="ni ni-menu"></em></a>
                                        </div>
                                    </div>
                                </div>
                                <div className="sidebar sidebar-user-mobile">
                                    <a href="#" className="icon-btn menu-toggler-user-close">
                                        <em className="ni ni-cross"></em>
                                    </a>
                                    <div className="sidebar-widget">
                                        <ul className="user-nav">
                                            <li className={activeSection === 'profile' ? 'active' : ''}>
                                                <a href="#" onClick={() => setActiveSection('profile')}><i className="fa fa-pencil"></i> Profile</a>
                                            </li>
                                            <li className={activeSection === 'account' ? 'active' : ''}>
                                                <a href="#" onClick={() => setActiveSection('account')}><i className="fa fa-user"></i> Account</a>
                                            </li>
                                            {/* <li><a href="#"><i className="fa fa-qrcode"></i> Wallet</a></li> */}
                                            <li className={activeSection === 'verify' ? 'active' : ''}><a href="#" onClick={() => setActiveSection('verify')}><i className="fa fa-check-circle-o"></i> Request verification</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-7 offset-lg-1 menur">
                                {activeSection === 'profile' && (
                                    <div className="profile">
                                        <h1 className="pb-20 title-mt">Edit profile</h1>
                                        <form id="form-create-item" className="form-border" method="post" action="email.php">
                                            <div className="field-set">
                                                <h5>Upload banner</h5>
                                                <div className="d-create-file">
                                                    <img src="images/author_single/author_banner.jpg" id="click_banner_img" className="d-banner-img-edit img-fluid" alt="" />
                                                    <p id="file_name">PNG, JPG, GIF, WEBP. Max 5mb. Recommended size : 2500x650px</p>
                                                    <input type="button" id="get_file" className="btn-main" value="Browse" />
                                                    <input type="file" id="upload_banner" />
                                                </div>

                                                <div className="spacer-40"></div>

                                                <h5>Upload profile image</h5>
                                                <div className="d-create-file">
                                                    <img src="images/author_single/author_thumbnail.jpg" id="click_profile_img" className="d-profile-img-edit img-fluid" alt="" />
                                                    <p id="file_name">PNG, JPG, GIF, WEBP. Max 5mb. Recommended size : 512x512px</p>
                                                    <input type="button" id="get_file" className="btn-main" value="Browse" />
                                                    <input type="file" id="upload_file" />
                                                </div>

                                                <div className="spacer-40"></div>

                                                <h5>Display Name <span style={{ fontSize: '13px', color: 'darkgray' }}>(Optional)</span></h5>
                                                <input type="text" name="item_title" id="item_title" className="form-control" placeholder="Enter your display name" />

                                                <div className="spacer-20"></div>

                                                <h5>Username</h5>
                                                <div className="input-group mb-3">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text" id="username">@</span>
                                                    </div>
                                                    <input type="text" name="item_user" id="item_user" className="form-control" placeholder="e.g. 'Enter your username" />
                                                </div>

                                                <h5>Type<span style={{ fontSize: '13px', color: 'darkgray' }}></span></h5>
                                                <div className="form-group">
                                                    <select
                                                        id="selectType"
                                                        className="form-control"
                                                        onChange={(e) => console.log(e.target.value)}
                                                    >
                                                        <option value="artist">Artist</option>
                                                        <option value="gallery">Gallery</option>
                                                        <option value="gallery">Collector</option>        <option value="gallery">Visitor</option>


                                                    </select>
                                                </div>
                                                <div className="spacer-20"></div>

                                                <h5>Short bio <span style={{ fontSize: '13px', color: 'darkgray' }}>(Optional)</span></h5>
                                                <textarea data-autoresize name="item_desc" id="item_desc" className="form-control" placeholder="e.g. 'Tell about yourself'"></textarea>

                                                <div className="spacer-10"></div>

                                                <h5>Custom link <span style={{ fontSize: '13px', color: 'darkgray' }}>(Optional, only for verified accounts. This will be your personal and unique gallery page.)</span></h5>
                                                <div className="input-group mb-3">
                                                    <input type="text" name="item_link" id="weblink" className="form-control" placeholder="yourname.gallery3.xyz" />
                                                    <div className="input-group-append">
                                                        <span className="input-group-text" id="customlink">.gallery3.xyz</span>
                                                    </div>
                                                </div>

                                                <div className="spacer-10"></div>

                                                <h5>Social links</h5>
                                                <div className="input-group mb-0">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text" id="social1">Website https://</span>
                                                    </div>
                                                    <input type="text" className="form-control" id="basic-url" aria-describedby="basic-addon3" />
                                                </div>
                                                <div className="input-group mb-0">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text" id="social2">Instagram</span>
                                                    </div>
                                                    <input type="text" className="form-control" id="basic-url" aria-describedby="basic-addon3" />
                                                </div>
                                                <div className="input-group mb-0">
                                                    <div className="input-group-prepend">
                                                        <span className="input-group-text" id="social3">X (Twitter)</span>
                                                    </div>
                                                    <input type="text" className="form-control" id="basic-url" aria-describedby="basic-addon3" />
                                                </div>
                                                <div className="spacer-40"></div>

                                                <input type="button" id="submit" className="btn-main" value="Update"  onClick={handleSubmit} />
                                            </div>
                                        </form>
                                    </div>
                                )}
                                {activeSection === 'account' && (
                                    <div className="account">
                                        <h1>Account</h1>
                                        <h5>Connected wallet <span style={{ fontSize: '13px', color: 'darkgray' }}></span></h5>
                                        <div className="input-group mb-3">
                                            <input type="text" readOnly name="item_wallet" id="weblink" className="form-control" placeholder="Your wallet address" />

                                        </div>

                                        <div className="spacer-20"></div>
                                        <h5>Email <span style={{ fontSize: '13px', color: 'darkgray' }}>(for marketplace notifications)</span></h5>
                                        <div className="input-group mb-3">
                                            <input type="text" name="item_mail" id="weblink" className="form-control" placeholder="Your email" />

                                        </div>

                                        <div className="spacer-20"></div>


                                        <h5>Danger zone <span style={{ fontSize: '13px', color: 'darkgray' }}>(once you delete your account, there is no going back. Please be certain.)</span></h5>

                                        <div className="spacer-40"></div>

                                        <input type="button" id="submit" className="btn-main" value="Update" />
                                        <input type="button" id="delete" className="btn-main red" value="Delete my account" />


                                    </div>
                                )}
                                {activeSection === 'verify' && (
                                    <div className="verify">
                                        <h1>Request verification</h1>
                                        <p>Proceed with verification process to get more visibility and gain trust on Gallery3. Every artwork and collection offered through Gallery3 goes through a multi-step process to ensure its authenticity. Every project requires at least 3 proofs of identity, more if needed. The Gallery3 team verifies the online identities and more.

</p>
                                        <br />
                                        <h4>Benefits of verification:</h4>
                                        <p><ul><li>A badge next to your name</li></ul></p>
                                        <h4>Getting Verified:</h4>
                                        <ul>
                                            <li>Connect your X (Twitter) or Instagram account to your profile</li>
                                            <li><a href="#" onClick={(e) => {
                                                e.preventDefault();
                                                setActiveSection('verificationForm');
                                            }}>Fill out the verification request form <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.666748 7.33341L7.33341 0.666748M7.33341 0.666748H0.666748M7.33341 0.666748V7.33341" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></a></li>
                                        </ul>
                                        <h4>Verification Criteria:</h4>
                                        <ul>
                                            <li>Relevant work history on Gallery3 or other platforms</li>
                                            <li>No history of unusual or fraudulent activity</li>
                                            <li>Verifiable identity</li>
                                        </ul>
                                        <h4>Tips for Successful Verification:</h4>
                                        <ul>
                                            <li>Link your X (Twitter) or Instagram account to your profile</li>
                                            <li>Publish work on Gallery3 to establish artistic identity</li>
                                            <li>Have multiple minted works and/or a substantial external body of work</li>
                                        </ul>
                                        <p>Note: Verification is not mandatory for minting (unless you are a gallery) but adds trust and authenticity. Lack of verification does not restrict minting.<br />
                                            <a style={{ marginTop: '20px', display: 'block' }} href="/learn">Learn more about verification<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.666748 7.33341L7.33341 0.666748M7.33341 0.666748H0.666748M7.33341 0.666748V7.33341" stroke="currentColor" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"></path></svg></a>
                                        </p>

                                        {/* <input type="button" className="btn-main" value="Verify via IG" />
                                    <input type="button" className="btn-main" value="Verify via X" />
                                    <input type="button" className="btn-main" value="Verify as a gallery" />
                                    <div className="spacer-20"></div>

                                    <input type="button" id="submit" className="btn-main" value="Update" /> */}


                                    </div>
                                )}
                                {/* Verification Form Section */}
                                {activeSection === 'verificationForm' && (
                                    <div className="verification-form">
                                        <a href="#" style={{ color: 'black', display: 'block', marginBottom: '10px' }} onClick={(e) => {
                                            e.preventDefault();
                                            setActiveSection('verify');
                                        }} class="fw-semibold"><i class="fa fa-fw" title="Collectible"></i> Back</a>

                                        <h1>Verification process</h1>
                                        <div className="spacer-20"></div>
                                        <form>
                                            <h5>Are you an Artist or a Gallery?<span style={{ fontSize: '13px', color: 'darkgray' }}></span></h5>
                                            <div className="form-group">
                                                <select
                                                    id="selectType"
                                                    className="form-control"
                                                    onChange={(e) => console.log(e.target.value)}
                                                >
                                                    <option value="artist">Artist</option>
                                                    <option value="gallery">Gallery</option>
                                                </select>
                                            </div>
                                            <div className="spacer-40"></div>
                                            <h5>TON wallet address <span style={{ fontSize: '13px', color: 'darkgray' }}>
                                                (Enter the TON wallet address you would like to have verified)</span></h5>
                                            <div className="input-group mb-3">
                                                <input type="text" name="item_mail" id="weblink" className="form-control" placeholder="e.g. 0x121233.." />

                                            </div>
                                            <div className="spacer-20"></div>
                                            <h5>Instagram or X (Twitter) account <span style={{ fontSize: '13px', color: 'darkgray' }}>(Enter the handle of the account linked to your Gallery3 profile
                                                )</span></h5>
                                            <div className="input-group mb-3">
                                                <input type="text" name="item_mail" id="weblink" className="form-control" placeholder="e.g. @gallery" />

                                            </div>
                                            <div className="spacer-20"></div>
                                            <h5>Gallery3 profile <span style={{ fontSize: '13px', color: 'darkgray' }}>(Link your Gallery3 profile (should be in the format of https://gallery3.xyz/user/0x12345....).
                                                )</span></h5>
                                            <div className="input-group mb-3">
                                                <input type="text" name="item_mail" id="weblink" className="form-control" placeholder="e.g. https://wwwq.gallery3.xyx/user/3131.." />

                                            </div>
                                            <div className="spacer-20"></div>

                                            <h5>Other works
                                                <span style={{ fontSize: '13px', color: 'darkgray' }}> (Please provide links to other works you may have published on other platforms.)</span></h5>
                                            <div className="input-group mb-3">
                                                <textarea data-autoresize name="item_desc" id="item_desc" className="form-control" placeholder="e.g. 'Tell about yourself'"></textarea>
                                            </div>
                                            <div className="spacer-40"></div>

                                            <input type="button" id="submit" className="btn-main" value="Submit" />

                                        </form>
                                    </div>
                                )}


                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* Footer */}
            <Footer />

        </div>
    );
}

export default EditProfile;